<div class="dashboard-releases-dialog">
  <dashboard-dialog-title [title]="'Latest Releases'"></dashboard-dialog-title>
  <mat-dialog-content>
    <dashboard-release-notes-list></dashboard-release-notes-list>
  </mat-dialog-content>
</div>
